/* eslint-disable consistent-return, consistent-return, prefer-destructuring */
import axios from 'axios'
import FormData from 'form-data'
import { get, map } from 'lodash'
import qs from 'qs'

export function getObjectKey(data) {
  const { objectName } = data
  let objectKey = ''

  switch (objectName) {
    case 'organisation':
      if (data.documentUrl) {
        if (data.documentUrl.match(/(organisation\S+)$/i)) {
          objectKey = data.documentUrl.match(/(organisation\S+)$/i)[0]
        } else if (data.documentUrl.match(/(Account\S+)$/i)) {
          objectKey = data.documentUrl.match(/(Account\S+)$/i)[0]
        } else if (data.documentUrl.match(/(LandingPage\S+)$/i)) {
          objectKey = data.documentUrl.match(/(LandingPage\S+)$/i)[0]
        }
      }
      break
    case 'event':
      if (data.documentUrl) {
        if (data.documentUrl.match(/(event\S+)$/i)) {
          objectKey = data.documentUrl.match(/(event\S+)$/i)[0]
        }
      }
      break
    case 'eventDocument':
      if (data.documentUrl) {
        if (data.documentUrl.match(/(event\S+)$/i)) {
          objectKey = data.documentUrl.match(/(eventDocument\S+)$/i)[0]
        }
      }
      break
    case 'displaySetting':
      if (data.documentUrl) {
        if (data.documentUrl.match(/(displaySetting\S+)$/i)) {
          objectKey = data.documentUrl.match(/(displaySetting\S+)$/i)[0]
        }
      }
      break
    case 'sponsor':
      if (data.documentUrl) {
        if (data.documentUrl.match(/(sponsor\S+)$/i)) {
          objectKey = data.documentUrl.match(/(sponsor\S+)$/i)[0]
        }
      }
      break
    case 'productImage':
      if (data.documentUrl) {
        if (data.documentUrl.match(/(productImage\S+)$/i)) {
          objectKey = data.documentUrl.match(/(productImage\S+)$/i)[0]
        }
      }
      break
    case 'teamLogo':
      if (data.documentUrl) {
        if (data.documentUrl.match(/(teamLogo\S+)$/i)) {
          objectKey = data.documentUrl.match(/(teamLogo\S+)$/i)[0]
        }
      }
      break
    case 'shopDisplayTemplate':
      if (data.documentUrl) {
        if (data.documentUrl.match(/(shopDisplayTemplate\S+)$/i)) {
          objectKey = data.documentUrl.match(/(shopDisplayTemplate\S+)$/i)[0]
        }
      }
      break
    case 'memberProfile':
      objectKey =
        // biome-ignore lint/complexity/useOptionalChain: TODO
        data.documentUrl && data.documentUrl.match(/(memberProfile\S+|profileImage\S+)$/i)
          ? data.documentUrl.match(/(memberProfile\S+|profileImage\S+)$/i)[0]
          : null
      break
    default:
      if (data.documentUrl) {
        if (data.documentUrl.match(new RegExp(`(${objectName}\\S+)$`, 'i'))) {
          objectKey = data.documentUrl.match(new RegExp(`(${objectName}\\S+)$`, 'i'))[0]
        }
      }
      break
  }
  return objectKey
}

export function getDownloadUrl(data) {
  const objectKey = getObjectKey(data.documentUrl)
  return `?key=${objectKey}${
    data.format === 'pdf' ? `&documentName=${data.name}` : `&isImage=true&isDownload=true&documentName=${data.name}`
  }`
}

export function getPreviewUrl(data) {
  const objectKey = getObjectKey(data)
  let params = {
    key: objectKey,
    application: data.application,
    component: data.objectName,
  }

  switch (data.format) {
    case 'docx':
    case 'xlsx':
    case 'xls':
      params = {
        ...params,
        isPreview: false,
        isImage: false,
      }
      break
    default:
      params = {
        ...params,
        isPreview: true,
        ...(data.format !== 'pdf'
          ? {
              isImage: true,
            }
          : {}),
      }
      break
  }

  return `?${qs.stringify(params)}`
}

export function upload({ file, info, url }) {
  return new Promise((resolve, reject) => {
    const formData = new FormData()
    formData.append('file', file)
    map(info, (value, key) => {
      formData.append(key, value)
    })

    const request = {
      url,
      method: 'post',
      data: formData,
    }
    axios(request)
      .then(response => {
        if (get(response, 'data.success')) {
          return resolve(get(response, 'data.data'))
        }
        reject(new Error(get(response, 'data.error') || 'Something went wrong'))
      })
      .catch(err => {
        reject(new Error(`Something went wrong: ${err.response.data}`))
      })
  })
}

export function download({ file, info, url }) {
  return new Promise((resolve, reject) => {
    const request = {
      url: `${url}?${qs.stringify(info)}&isImage=true&key=${encodeURIComponent(file)}`,
      method: 'get',
    }
    axios(request)
      .then(response => {
        if (response.status < 300) {
          return resolve(get(response, 'data.data'))
        }
        reject(new Error(get(response, 'data.error') || 'Something went wrong'))
      })
      .catch(() => {
        reject(new Error('Something went wrong'))
      })
  })
}
